import React from 'react';
import PropTypes from 'prop-types';
import MathJax from 'react-mathjax4';
import useStyles from "sdk/custom-hooks/useStyles";
import useUserLanguage from "sdk/custom-hooks/useUserLanguage";
import { editor } from 'sdk/common';
import {Box, Typography} from '@material-ui/core';
/**
 * Direction of a question.
 * @param props
 * @returns {*}
 * @constructor
 */
function QuestionDirection(props) {
    const { direction, localesDirection } = props;
    const classes = useStyles(styles)();
    const directionType = direction?.type?.toUpperCase();
    const quizDirectionClass = directionType === 'LONG_TEXT' ? classes.quizDirectionBlock : '';
    const { language } = useUserLanguage();
    const directionContent = localesDirection || direction?.direction || '';

    // convert math type question readable format
    editor(directionContent);
    
    return (
        <Box className={classes.quizDirection + ' ' + classes.box + ' ' + quizDirectionClass}>
            {direction?.direction ?
                <Typography variant='h4'>
                    {(language === 'hn') && <MathJax.Context input="tex">
                        <MathJax.Html html={directionContent}/>
                    </MathJax.Context>}
                </Typography> : null}
            <Typography variant='h4'>
                {(language === 'en') && <MathJax.Context input="tex">
                    <MathJax.Html html={directionContent}/>
                </MathJax.Context>}
            </Typography>
        </Box>
    );
}

QuestionDirection.propTypes = {
    direction: PropTypes.shape({
        type: PropTypes.string,
        direction: PropTypes.string,
    }),
    localesDirection: PropTypes.string,
};

const styles = theme => ({
    quizDirection: {
        width: '50%',
        '@media (max-width:767px)': {
            display: 'none'
        },
    },
    quizDirectionBlock: {
        maxHeight: 'calc(100vh - 190px)',
        overflow: 'auto'
    },
    box: {
        overflow: 'auto',
        maxHeight: 'calc(100vh - 190px)',
        float: 'left',
        width: 'calc(100% - 20px)',
        boxShadow: '0 0 2px #ccc',
        margin: 10,
        backgroundColor: '#fff',
        position: 'relative',
        textAlign: 'left',
        padding: 10,
        '&::-webkit-scrollbar': {
            width: 6,
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#d3d5d3'
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#eeecec'
        },
        '& h4': {
            fontWeight: 'normal'
        }
    }
});

export default QuestionDirection;
